export default function Footer() {
  return (
    <div>
      Click{" "}
      <a
        className="underline cursor-pointer"
        rel="noreferrer noopener"
        href="https://market-plus-shop.myshopify.com/pages/insider-nfts"
      >
        here
      </a>{" "}
      to learn more
    </div>
  );
}
